import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProviderDashboard from "../../components/providerPortal/ProviderDashboard";
import { fetchProviderDashboard } from "../../store/providerPortal/actions";
import * as types from "../../store/providerPortal/types";

const ProviderDashboardContainer = () => {
  const dispatch = useDispatch();
  const { dashboard } = useSelector((state) => state.providerPortal);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = () => {
    dispatch(fetchProviderDashboard()).payload.then(
      (response) => {
        dispatch({
          type: types.FETCH_PROVIDER_DASHBOARD_SUCCESS,
          payload: response.data,
        });
      },
      (error) => {
        dispatch({
          type: types.FETCH_PROVIDER_DASHBOARD_FAILURE,
          payload: error.response?.data || error.message,
        });
      }
    );
  };

  return (
    <ProviderDashboard
      dashboard={dashboard.data}
      loading={dashboard.loading}
      error={dashboard.error}
      onRefresh={loadDashboard}
    />
  );
};

export default ProviderDashboardContainer;
